import type Chapter from '@audacy-clients/client-services/src/dataServices/Chapter';
import { type Transcript } from '@audacy-clients/client-services/src/dataServices/Episode';

export type IChapter = {
  index: number;
  duration: number;
  startOffset: number;
  title?: string;
  transcript: Transcript;
}

export const wrapChapter = (chapter: Chapter, index: number): IChapter => ({
  index,
  duration: chapter?.getDuration(),
  startOffset: chapter.getStartOffset(),
  title: chapter.getTitle(),
  transcript: chapter.getTranscript(),
});

export const wrapChapters = (chapters: Array<Chapter>): Array<IChapter> => chapters.map(wrapChapter);
